<template lang="pug">
div
  e-z-toolbar(
    :title="'Orders'",
    @counterSelected="onCounterSelect()",
    @sectionSelected="onSectionSelect()",
    @allSelected="openRestaurant($event)"
  )
  v-container.pa-0(fluid)
    v-row(justify-left, no-gutters)
      v-col(
        v-for="group in orderGroups",
        :key="group.name",
        cols="12",
        xs="12",
        sm="6",
        md="4",
        lg="3",
        xl="2"
      )
        v-sheet(color="grey lighten-2")
          v-row(no-gutters)
            v-col.pl-3.pr-3
              div(style="float:left")
                v-icon(small) mdi-plus-box-multiple
                strong.pl-2 {{ group.name }}: ({{ group.orders.length }})
              div(
                v-if="group.isPrintable",
                style="float:right",
                @click="vibrate(); printOrders(group.orders)"
              )
                v-icon(small) mdi-printer
                strong Print
          v-divider
          e-z-order-list(:orders="group.orders", :options="{ mode: 'exec' }") Loading...
</template>

<script>
import moment from "moment";
import { storeMixin } from "../mixins/storeMixin.js";
import EZToolbar from "../components/shared/EZToolbar.vue";
import EZOrderList from "../components/shared/EZOrderList.vue";

export default {
  name: "orders",
  mixins: [storeMixin],
  components: { EZToolbar, EZOrderList },
  data() {
    return {
      collectionName: "orders",
      isCounterOpen: false,
      isRestaurantOpen: false,
      routeParams: {},
    };
  },
  computed: {
    orderGroups() {
      const workflowEnabled = this.myFeatures.eligibleFeatures.includes(
        "WORKFLOW"
      );
      const intermediateGroups = workflowEnabled
        ? [
            {
              name: "Prep-in-progress",
              orders: this.restaurantOrders.filter(
                (o) => o.status === this.STATUSES.PREPON
              ),
            },
            {
              name: "Ready to pick",
              orders: this.restaurantOrders.filter(
                (o) => o.status === this.STATUSES.READY
              ),
            },
            {
              name: "On the way to table",
              orders: this.restaurantOrders.filter(
                (o) => o.status === this.STATUSES.INTRANSIT
              ),
            },
            {
              name: "Served",
              orders: this.restaurantOrders.filter(
                (o) => o.status === this.STATUSES.SERVED
              ),
            },
          ]
        : [
            {
              name: "Cleared",
              orders: this.restaurantOrders.filter((o) =>
                [
                  this.STATUSES.CLEARED,
                  // this.STATUSES.CLEARED
                ].includes(o.status)
              ),
            },
          ];
      let groups = this.isRestaurantOpen
        ? [
            {
              name: "In-cart",
              orders: this.restaurantOrders.filter(
                (o) => o.status === this.STATUSES.INCART
              ),
            },
            {
              name: "On-counter",
              isPrintable: true,
              orders: this.restaurantOrders.filter((o) =>
                workflowEnabled
                  ? o.status === this.STATUSES.QUEUED
                  : [
                      this.STATUSES.QUEUED,
                      this.STATUSES.PREPON,
                      this.STATUSES.READY,
                      this.STATUSES.INTRANSIT,
                    ].includes(o.status)
              ),
            },
            ...intermediateGroups,
          ]
        : [
            {
              name: this.isCounterOpen ? "In Cart" : "In Queue",
              orders: this.isCounterOpen
                ? this.counterOrders.filter(
                    (o) => o.status == this.STATUSES.INCART
                  )
                : this.sectionOrders.filter(
                    (o) => o.status < this.STATUSES.READY
                  ),
            },
            {
              name: this.isCounterOpen ? "Confirmed" : "To Pick",
              orders: this.isCounterOpen
                ? this.counterOrders.filter(
                    (o) => o.status == this.STATUSES.QUEUED
                  )
                : this.sectionOrders.filter(
                    (o) => o.status == this.STATUSES.READY
                  ),
            },
            {
              name: this.isCounterOpen ? "In-Progress" : "In-Transit",
              orders: this.isCounterOpen
                ? this.counterOrders.filter(
                    (o) => o.status == this.STATUSES.PREPON
                  )
                : this.sectionOrders.filter(
                    (o) => o.status == this.STATUSES.INTRANSIT
                  ),
            },
            {
              name: this.isCounterOpen ? "Ready" : "Served",
              orders: this.isCounterOpen
                ? this.counterOrders.filter(
                    (o) => o.status == this.STATUSES.READY
                  )
                : this.sectionOrders.filter(
                    (o) => o.status == this.STATUSES.SERVED
                  ),
            },
          ];
      return groups;
    },
    areas() {
      return [...this.counters, ...this.sections];
    },
  },
  methods: {
    onCounterSelect() {
      this.isCounterOpen = true;
      this.isRestaurantOpen = false;
    },
    onSectionSelect() {
      this.isCounterOpen = false;
      this.isRestaurantOpen = false;
    },
    openRestaurant() {
      this.isRestaurantOpen = true;
    },
    printOrders(orders) {
      //const maxCol = 32;
      let lines = [];
      orders.forEach((order) => {
        lines.push("--------------------------------");
        lines.push(
          `Counter:${order.counterCode} Section:${order.sectionCode} Seat:${order.seat}`
        );
        lines.push(
          `Timestamp: ${moment(order.lastUpdatedTS || order.createdTS).format(
            "DD-MMM-YYYY LT"
          )}`
        );
        lines.push(
          `${order.productName.padEnd(25, " ")} Qty[${order.quantity}]`
        ); //max-6
        lines.push(
          `Custom: ${
            order.tags && order.tags.length ? order.tags.join(",") : "Standard"
          }`
        );
        lines.push("--------------------------------");
      });
      this.print(lines.join("\n                                \n"));
    },
  },
};
</script>
<style>
.v-expansion-panel__header {
  padding-left: 6px;
  padding-top: 0px;
  padding-right: 6px;
  padding-bottom: 0px;
}
</style>
